<ng-container *ngFor="let comment of comments">
    <ui-comment [model]="comment"
                [editPermission]="editPermission"
                [disable]="currentUserId !== comment.userId"
                (edited)="onEditingComment($event)"
                (updated)="onUpdateComment($event)"
                (deleted)="onDeleteComment($event)">
    </ui-comment>
</ng-container>
<ng-container *ngIf="!comments.length">
    <em translate>comments_no_comments_info</em>
</ng-container>
